import React from "react";

const STATUS_LABELS = {
  published: "Publicado",
  in_progress: "En curso",
  partially_completed: "Parcial",
  completed: "Completado",
  scheduled: "Programado",
  band_assigned: "Banda asignada",
  measuring: "Midiendo",
  failed: "Fallido",
  no_show: "No asistió",
  cancelled: "Cancelado",
  rescheduled: "Reprogramado",
  absent: "Ausente",
  incomplete: "Incompleto",
  retry_required: "Reintento requerido",
};

const KioskStatusBadge = ({ status }) => {
  const value = status || "scheduled";
  const tone = value === "completed"
    ? "bg-emerald-50 text-emerald-700 border-emerald-100"
    : ["failed", "no_show", "cancelled", "absent", "incomplete"].includes(value)
      ? "bg-rose-50 text-rose-700 border-rose-100"
      : ["in_progress", "measuring", "partially_completed", "retry_required"].includes(value)
        ? "bg-amber-50 text-amber-700 border-amber-100"
        : "bg-slate-50 text-slate-600 border-slate-200";

  return (
    <span className={`inline-flex items-center rounded-full border px-2.5 py-1 text-[11px] font-bold ${tone}`}>
      {STATUS_LABELS[value] || value}
    </span>
  );
};

export { STATUS_LABELS };
export default KioskStatusBadge;
